import { pxToRem } from './px_to_rem'

let unitValue: number | undefined

/**
 * 转换 375 宽下的像素值为用户真实的像素值。
 *
 * @param px 像素值
 */
export function pxToRpx(px: number) {
  if (unitValue == null) {
    const doc = document.createElement('div')
    doc.style.position = 'absolute'
    doc.style.visibility = 'hidden'
    doc.style.margin = '0px'
    doc.style.padding = '0px'
    doc.style.height = `${pxToRem(1)}rem`
    document.body.appendChild(doc)
    unitValue = doc.clientHeight
    document.body.removeChild(doc)
  }
  return px * unitValue
}
